import { render, staticRenderFns } from "./BusinessViewHeader.vue?vue&type=template&id=68b7e8da&scoped=true&"
import script from "./BusinessViewHeader.vue?vue&type=script&lang=js&"
export * from "./BusinessViewHeader.vue?vue&type=script&lang=js&"
import style0 from "./BusinessViewHeader.vue?vue&type=style&index=0&id=68b7e8da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b7e8da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRating } from 'vuetify/lib/components/VRating';
installComponents(component, {VAvatar,VBtn,VIcon,VImg,VRating})
